export default __webpack_public_path__ + "static/media/051-pi.dbcf26e6.svg";